import Table from './table.js';

export default Table;